/* global dataLayer */
import debug from 'debug'
const dbg = debug('plugin:ga')

export default function install (Vue, options = {}) {
  if (process.env.NODE_ENV !== 'production') {
    dbg('Not production environment. Ignore Google Analytics')
    return
  }

  const tracker = window.runtimeConfig?.GATRACKER
  if (!tracker) {
    dbg('Missing GRTRACKER runtime variable. Ignore Google Analytics')
  }

  dbg('Setup Google Analytics')
  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${tracker}`
  document.head.appendChild(script)
  script.onerror = err => dbg(err)

  window.dataLayer = window.dataLayer || []
  function gtag () { dataLayer.push(arguments) }
  gtag('js', new Date())
  gtag('config', tracker)
}
